<template>
    <header class="bg-white shadow-md py-1.5 px-3">
        <div class="flex items-center justify-between">
            <!-- 햄버거 메뉴 (모바일) -->
            <button v-if="showMenuButton" @click="toggleMobileSidebar"
                class="lg:hidden text-gray-600 focus:outline-none">
                <MenuIcon size="18" />
            </button>

            <h2 class="text-sm font-semibold text-gray-800 cursor-pointer" @click="$emit('title-click')">{{ title }}
            </h2>
            <div class="flex items-center space-x-2">
                <!-- 알림 아이콘 주석 처리
                <div class="relative cursor-pointer" @click="toggleNotifications">
                    <BellIcon class="text-gray-600" />
                    <span v-if="notificationCount > 0"
                        class="absolute top-0 right-0 -mt-1 -mr-1 px-2 py-1 text-xs bg-red-500 text-white rounded-full">
                        {{ notificationCount }}
                    </span>

                    <div v-if="showNotifications" class="fixed inset-0 z-40" @click.stop="toggleNotifications"></div>

                    <div v-if="showNotifications"
                        class="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                        <div class="p-4 border-b">
                            <div class="flex justify-between items-center">
                                <h3 class="text-lg font-semibold">알림</h3>
                                <button @click="markAllAsRead" class="text-sm text-blue-500 hover:text-blue-600">
                                    모두 읽음
                                </button>
                            </div>
                        </div>
                        <div class="max-h-96 overflow-y-auto">
                            <div v-for="notification in notifications" :key="notification.id"
                                @click="handleNotificationClick(notification)"
                                class="p-4 hover:bg-gray-50 border-b last:border-b-0 cursor-pointer">
                                <div class="flex items-start space-x-3">
                                    <div class="flex-shrink-0 mt-1">
                                        <span v-if="!notification.isRead"
                                            class="block w-2 h-2 bg-blue-500 rounded-full"></span>
                                    </div>
                                    <div>
                                        <p class="text-sm font-medium">{{ notification.message }}</p>
                                        <p class="text-xs text-gray-500 mt-1">{{ formatDate(notification.date) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-4 text-center">
                            <button class="text-sm text-blue-500 hover:text-blue-600">
                                모든 알림 보기
                            </button>
                        </div>
                    </div>
                </div>
                -->
                <!-- Profile Menu Container -->
                <div class="relative">
                    <!-- Profile Button -->
                    <div @click="toggleProfileMenu" class="flex items-center space-x-1.5 focus:outline-none">
                        <div class="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
                            <UserIcon size="14" class="text-gray-600" />
                        </div>
                        <div class="hidden sm:block">
                            <span class="text-xs text-gray-700 font-medium block">{{ authStore.user?.branchName
                                }}</span>
                        </div>
                        <ChevronDownIcon size="12" class="text-gray-500" />
                    </div>

                    <!-- Overlay -->
                    <div v-if="isProfileMenuOpen" class="fixed inset-0 z-20" @click="toggleProfileMenu"></div>

                    <!-- Dropdown Menu -->
                    <div v-if="isProfileMenuOpen"
                        class="absolute right-0 mt-2 w-44 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-30">
                        <div class="py-1" role="menu">
                            <button @click="goToProfile"
                                class="w-full text-left px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-100"
                                role="menuitem">
                                <UserIcon size="14" class="inline-block mr-2" />
                                내 정보 관리
                            </button>
                            <button @click="handleLogout"
                                class="w-full text-left px-3 py-1.5 text-xs text-red-600 hover:bg-gray-100"
                                role="menuitem">
                                <LogOutIcon size="14" class="inline-block mr-2" />
                                로그아웃
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { ChevronDownIcon, UserIcon, LogOutIcon, MenuIcon } from 'lucide-vue-next'
import { authAPI, removeToken } from '@/api/apiClient'

const authStore = useAuthStore()
const router = useRouter()
const isProfileMenuOpen = ref(false)

const emit = defineEmits(['toggle-mobile-sidebar', 'toggle-notifications', 'notification-click', 'title-click'])

defineProps({
    title: {
        type: String,
        required: true
    },
    showMenuButton: {
        type: Boolean,
        default: true
    }
})

const toggleMobileSidebar = () => {
    emit('toggle-mobile-sidebar')
}

const toggleProfileMenu = () => {
    isProfileMenuOpen.value = !isProfileMenuOpen.value
}

const handleLogout = async () => {
    try {
        await authAPI.logout()
        removeToken()
        authStore.$reset()
        router.push('/login')
    } catch (error) {
        console.error('로그아웃 중 오류 발생:', error)
    }
}

const goToProfile = () => {
    router.push('/profile')
    isProfileMenuOpen.value = false
}
</script>

<style scoped>
.absolute {
    position: absolute;
}

@media print {
    header {
        display: none !important;
    }
}
</style>